import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step3 } from '../../../../shared/models/component-messages/mapaRE/step3';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { TypeCPVClass } from '../models/TypeCPVClass';
import { TypeObjCPV } from '../models/TypeObjCPV';
@Component({
  selector: 'app-type-objCPV',
  templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeObjCPV';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() cpv: TypeObjCPV;

  public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
    if (this.cpv.objetComplementaire === null) {
      this.cpv.objetComplementaire = [];
    }
  }


  addtypeCPVClass() {
    if (this.cpv.objetComplementaire.length < 4) {
      this.cpv.objetComplementaire.push(new TypeCPVClass());
    }
  }

  removetypeCPVClass(i) {
    ArrayPopTools.pop(this.cpv.objetComplementaire, i, this.parentForm, this.getUid());
  }



  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  chargeDonneePreference(preference: Preference) {
    for (let index = 0; index < preference?.content?.values.length; index++) {
      const element = preference?.content?.values[index];
      if (index === 0) {
        this.parentForm.get(this.getUid() + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code);
        this.parentForm.get(this.getUid() + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched();
      } else {
        if (this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale') === null) {
          this.addtypeCPVClass();
          setTimeout(() => {
            this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code)
            this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched()
          }, 100)
        } else {
          this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code);
          this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched();
        }
      }

    }
  }

}

